<template>
  <router-view />
</template>
<script>
import { useStore } from '@/store'

export default {
  created() {
    useStore().fetchFeatures()
  },
}
</script>
